import AppliedMarketplaceFilters from './AppliedMarketplaceFilters'

export default AppliedMarketplaceFilters
